import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { useCookies } from "react-cookie";
import { Navigate } from "react-router-dom";
import { API_URL } from "src/config";
import axios from "axios";
// import refreshAccessToken from './views/refresh-token/RefreshToken'
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

function AuthenticatedRoute({ children }) {
  const [cookiesValue, setCookiesValue] = useState(Cookies.get("access_token"));
  const [isLoading, setIsLoading] = useState(!!Cookies.get("access_token"));
  const navigate = useNavigate();

  const validTokens = useCallback(async (token) => {
    try {
      const response = await axios.post(
        `${API_URL}/token/verify/`,
        { token },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      if (response.status === 200) {
        setIsLoading(false);
      } else {
        throw new Error("Invalid token");
      }
    } catch (error) {
      console.error("Token verification failed:", error);
      Cookies.remove("access_token");
      Cookies.remove("refresh_token");
      setCookiesValue(undefined);
      setIsLoading(false);
      navigate("/login");
    }
  }, [navigate]);

  useEffect(() => {
    const token = Cookies.get("access_token");
    if (token) {
      validTokens(token);
    } else {
      setIsLoading(false);
    }
  }, [validTokens]);

  if (isLoading) {
    return (
      <div className="pt-3 text-center">
        <div className="sk-spinner sk-spinner-pulse"></div>
      </div>
    );
  }

  return cookiesValue ? children : <Navigate to="/login" replace />;
}

AuthenticatedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthenticatedRoute;
